"use strict";

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _elementUi = require("element-ui");

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, roles, accessRoutes;
    return _index.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // set page title


            document.title = (0, _getPageTitle.default)(to.meta.title); // determine whether the user has logged in

            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 34;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });

            _nprogress.default.done();

            _context.next = 32;
            break;

          case 9:
            hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 32;
            break;

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return _store.default.dispatch('user/getInfo');

          case 17:
            roles = _context.sent;
            _context.next = 20;
            return _store.default.dispatch('permission/generateRoutes', roles);

          case 20:
            accessRoutes = _context.sent;

            _router.default.addRoutes(accessRoutes);

            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
            _context.next = 32;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](14);
            _context.next = 29;
            return _store.default.dispatch('user/resetToken');

          case 29:
            _elementUi.Message.error(_context.t0 || 'Has Error');

            next("/login?redirect=".concat(to.path));

            _nprogress.default.done();

          case 32:
            _context.next = 35;
            break;

          case 34:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));

              _nprogress.default.done();
            }

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 25]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});